import { BaseSection, VStack } from '@sevenrooms/ui-kit/layout'
import type { ThemeColor } from '@sevenrooms/ui-kit/theme'
import { useOtherAvailabilitySectionBaseSpacing } from './useOtherAvailabilitySectionBaseSpacing'
import type { PropsWithChildren } from 'react'

export interface OtherAvailabilitySectionProps {
  title: string
  collapsed: boolean
  setCollapsed: (collapsed: boolean) => void
  backgroundColor?: ThemeColor | undefined
  'data-test'?: string
}

export function OtherAvailabilitySection({
  title,
  collapsed = true,
  setCollapsed,
  backgroundColor = 'secondaryBackground',
  'data-test': dataTest,
  children,
}: PropsWithChildren<OtherAvailabilitySectionProps>) {
  const baseSpacing = useOtherAvailabilitySectionBaseSpacing()

  return (
    <BaseSection
      title={title}
      collapsed={collapsed}
      onToggleCollapse={v => {
        setCollapsed(v)
      }}
      data-test={dataTest ?? 'other-availability'}
      backgroundColor={backgroundColor}
      borderWidth={0}
      padding="none"
      ml={baseSpacing}
      mr={baseSpacing}
      mt="sm"
      mb="sm"
      maxWidth="100%"
      type="h3"
    >
      <VStack pt="sm" pb={baseSpacing} pl={baseSpacing} pr={baseSpacing} spacing="lm">
        {children}
      </VStack>
    </BaseSection>
  )
}
